import Swiper, {Navigation, EffectFade , Thumbs, EffectCreative, Parallax} from 'swiper';

const certificatesSlider = (infoSliderClass = '.js-about-certificates', imageSliderClass = '.js-about-certificates-img') => {

    let infoSlider = new Swiper(infoSliderClass, {
        modules: [EffectFade],
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        initialSlide: 2,
        watchSlidesProgress: true,
    });

    let imageSwiper = new Swiper(imageSliderClass, {
        modules: [Navigation, Thumbs, EffectCreative, Parallax],
        slidesPerView: 1,
        loop: true,
        effect: "creative",
        speed: 600,
        resistanceRatio: 0,
        initialSlide: 2,
        parallax: true,
        watchSlidesProgress: true,
        grabCursor: true,
        creativeEffect: {
            limitProgress: 2,
            perspective: true,
            prev: {shadow: false, translate: ["15%", 0, -200]},
            next: {translate: ["100%", 0, 0]}
        },

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        thumbs: {
            swiper: infoSlider,
        },
    });
}

export default certificatesSlider;
